import "./emp-landing-navbar.scss"
import logo from "../../../assets/images/logo.svg"
import StyledButton from "../../shared/styled-button"
import { useEffect, useRef, useState } from "react";
import useEmpBreakpoint from "../../../hooks/useEmpBreakpoint";
import { motion } from "framer-motion";
import EmpAnimatedMenuBtn, { EmpAnimatedMenuBtnRef } from "../../shared/emp-animated-menu-btn/emp-animated-menu-btn";
import { useLocation, useNavigate } from "react-router-dom";
import { Color } from "../../../utilities/colors";

const menuVariant = {
    black: { backgroundColor: "rgba(0, 0, 0, 0.75)", transition: { duration: 0.2 } },
    grey: { backgroundColor: "rgba(22, 24, 26, 0.75)" },
    lightGrey: { backgroundColor: "#111315" }
};

type NavModeType = "dynamic" | "static"

const pageToNavConfigMapping: { [key: string]: { navMode: NavModeType, variant: string } } = {
    '/': {
        navMode: "dynamic",
        variant: "black"
    },
    '/enterprise-interest': {
        navMode: "static",
        variant: "lightGrey"
    },
}

export const EmpLandingNavbar = (props: any) => {

    const navigate = useNavigate();
    const location = useLocation();

    const [mobileMenuIsExpanded, setMobileMenuIsExpanded] = useState<boolean>(false)
    const mobileMenuBtnRef = useRef<EmpAnimatedMenuBtnRef>()
    const mobileMenuRef = useRef<HTMLDivElement>(null)
    const isMobile = useEmpBreakpoint(620)

    // Manages the current variant of the dropdown list.
    const [activeVariant, setActiveVariant] = useState("black")

    // A dynamic navMode animates the navbar bg color when user scroll past the first 100vh
    const [navMode, setNavMode] = useState<NavModeType>("static")

    useEffect(() => {
        const config = pageToNavConfigMapping[location.pathname]
        setNavMode(config.navMode)
        setActiveVariant(config.variant)
    }, [location])

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [])

    useEffect(() => {
        if (!mobileMenuBtnRef.current || !mobileMenuRef.current) return
        if (!isMobile) {
            setMobileMenuIsExpanded(false)
            mobileMenuBtnRef.current.toBarIcon()
            mobileMenuRef.current.style.height = "0px"
        }
    }, [isMobile])

    const handleScroll = () => {
        if (navMode !== "dynamic") return;

        const position = window.pageYOffset;
        if (position > window.innerHeight) {
            setActiveVariant("grey")
        } else {
            setActiveVariant("black")
        }

    }

    //Toggle the mobile menu animated button
    const toggleMobileMenu = () => {

        if (!mobileMenuBtnRef.current || !mobileMenuRef.current) return
        const isExpanded = !mobileMenuIsExpanded
        setMobileMenuIsExpanded(isExpanded)
        if (isExpanded) {
            mobileMenuBtnRef.current.toCloseIcon()
            mobileMenuRef.current.style.height = "calc(100vh - 80px)"
        } else {
            mobileMenuBtnRef.current.toBarIcon()
            mobileMenuRef.current.style.height = "0px"
        }
    }

    useEffect(() => {
    }, [])

    return (
        <motion.div
            variants={menuVariant}
            initial={"black"}
            animate={activeVariant}
            className="emrg-navbar">
            <div className="navbar-content">
                <div className="logo-wrapper">
                    <img srcSet={logo} className="logo" alt="Emplifive logo" src="logo" />
                </div>

                <ul>
                    <li onClick={() => navigate("/")} className="menu-item">
                        <div className="text-div center">
                            <span>Home</span>
                        </div>
                    </li>
                    <li className="menu-item">
                        <div className="text-div center">
                            <span>Pricing</span>
                        </div>
                    </li>
                    <li className="menu-item">
                        <div className="text-div center">
                            <span>Free Trial</span>
                        </div>
                    </li>
                </ul>
                <StyledButton onClick={() => { window.location.href = 'https://dev.emplifive.com'; }} style={{ height: 30 }} text="Login" />
                <div className="menu-btn-wrapper ml-4">
                    <EmpAnimatedMenuBtn
                        ref={mobileMenuBtnRef}
                        onClick={() => { toggleMobileMenu() }} />
                </div>
            </div>

            <div ref={mobileMenuRef} className="mobile-menu">
                <ul>
                    <li onClick={() => { navigate("/"); toggleMobileMenu() }}>
                        <span className="color-gray-100">Home</span>
                    </li>
                    <li>
                        <span className="color-gray-100">Pricing</span>
                    </li>
                    <li>
                        <span className="color-gray-100">Free Trial</span>
                    </li>
                </ul>

            </div>
        </motion.div>
    );
}

